/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from '@tanstack/react-query';

import { ApiError } from '@/shared/api/ApiError';
import { useNotifications } from '@/shared/ui/Notifications';

import { globalOnError } from './globalOnError';

export type UseAppQueryOptions<TData, TError> = UseQueryOptions<
  TData,
  TError
> & { customError?: boolean };

export function useAppQuery<
  TData = unknown,
  TError extends ApiError = ApiError,
>(options: UseAppQueryOptions<TData, TError>) {
  const { addNotification } = useNotifications();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const queryResult = useQuery<TData, TError>(options);

  useEffect(() => {
    // Обработка unauthorized данных
    if (queryResult.data && (queryResult.data as any).unauthorized) {
      // Удаляем query из кеша
      queryClient.removeQueries();

      return; // Прерываем дальнейшую обработку
    }

    if (queryResult.error && !options.customError) {
      globalOnError(queryResult.error, t, addNotification);
    }
  }, [
    queryResult.error,
    queryResult.data,
    options.customError,
    queryClient,
    addNotification,
    t,
  ]);

  return queryResult;
}
